// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2qpI7","fileDisabled":"File_fileDisabled__7INg3"};